import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import PublicLayout from "@/components/PublicLayout";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, CheckCircle2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error");
    } finally { setLoading(false); }
  };

  return (
    <PublicLayout>
      <div className="max-w-md mx-auto px-6 py-20">
        <Card className="rounded-3xl border-2 shadow-xl shadow-primary/5">
          <CardContent className="p-8">
            {sent ? (
              <div className="text-center" data-testid="forgot-password-sent">
                <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-100 text-emerald-600 flex items-center justify-center mb-4">
                  <CheckCircle2 className="w-6 h-6" aria-hidden="true" />
                </div>
                <h1 className="font-heading font-bold text-2xl">Comprova el teu correu</h1>
                <p className="text-sm text-muted-foreground mt-3">
                  Si <strong>{email}</strong> està registrat, hi rebràs un enllaç per restablir la contrasenya.
                </p>
                <p className="text-xs text-muted-foreground mt-4">L'enllaç caduca en 1 hora.</p>
                <Button asChild variant="outline" className="mt-6 rounded-full" data-testid="forgot-back-btn">
                  <Link to="/login"><ArrowLeft className="w-4 h-4 mr-2" aria-hidden="true" /> Tornar a l'accés</Link>
                </Button>
              </div>
            ) : (
              <>
                <div className="text-center mb-6">
                  <div className="w-14 h-14 mx-auto rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-4">
                    <Mail className="w-6 h-6" aria-hidden="true" />
                  </div>
                  <h1 className="font-heading font-bold text-2xl">Has oblidat la contrasenya?</h1>
                  <p className="text-sm text-muted-foreground mt-1">Indica el teu email i t'enviem un enllaç per restablir-la.</p>
                </div>
                <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
                  <div>
                    <Label>Correu electrònic</Label>
                    <Input type="email" required autoFocus autoComplete="email" className="mt-2 rounded-xl" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
                  </div>
                  <Button type="submit" disabled={loading} size="lg" className="w-full rounded-full h-12" data-testid="forgot-submit-btn">
                    <Mail className="w-4 h-4 mr-2" aria-hidden="true" /> {loading ? "Enviant…" : "Enviar enllaç"}
                  </Button>
                </form>
                <div className="text-center mt-4">
                  <Link to="/login" className="text-sm text-primary hover:underline" data-testid="forgot-back-link">
                    <ArrowLeft className="w-3 h-3 inline mr-1" aria-hidden="true" /> Tornar a l'accés
                  </Link>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </PublicLayout>
  );
}
